import React from 'react';
import { setAriaHiddenForPopup, setBodyStyleOverflow } from '../../redux/layoutReducer';
import LeoPopupBody  from './LeoPopupBody.jsx';
import { ReactReduxContext } from 'react-redux'
import { createPortal } from "react-dom";

class LeoPopup extends React.Component {

	componentDidMount() {
		this.context.store.dispatch((setBodyStyleOverflow('hidden')));
		setTimeout(() => this.context.store.dispatch((setAriaHiddenForPopup(false))), 100);
	}

	componentWillUnmount() {
		this.context.store.dispatch((setBodyStyleOverflow('auto')));
		this.context.store.dispatch((setAriaHiddenForPopup(true)));
	}

	render() {
		const layoutDiv = document.getElementById('leo-popup');
		return (
			<>
			{createPortal(<LeoPopupBody
			headline ={this.props.headline}
			onClose={this.props.onClose}
			children_={this.props.children}
			childComponent={this.props.childComponent}
		/>, layoutDiv)}
			</>
		);
	}
}

LeoPopup.contextType = ReactReduxContext;

export default LeoPopup;
